import { Observable } from 'rxjs';
import { IBaseService, IModelEntity } from '@pit/core';
import { IListResult } from './entity.data.service.interface';

export interface ILocalStorageProvider<T extends IModelEntity> extends IBaseService {

    cryptoKey?: string;
    entityName?: string;

    getCountAsync(): Promise<number>;

    clear: () => void;
    delete$: (entity: T) => Observable<T>;
    getAll$: () => Observable<T[]>;
    getById$: (id: number) => Observable<T>;
    //getByGuiId: (id: string) => Observable<T>;
    getIdExists$(id: number): Observable<boolean>;
    save$: (entity: T) => Observable<T>;
    saveMulti: (entities: T[]) => void;

    clearAsync: () => Promise<void>;
    deleteAsync: (entity: T) => Promise<T>;
    getAllAsync: () => Promise<T[]>;
    getByIdAsync: (id: number) => Promise<T>;
    //getByGuIdAsync: (id: string) => Promise<T>;
    getElementAtAsync: (index: number) => Promise<T>;
    getIdExistsAsync(id: number): Promise<boolean>;
    saveAsync: (entity: T) => Promise<T>;
    saveMultiAsync: (entities: T[]) => Promise<void>;

    syncSavedItemsToRemote(): boolean;
    syncSavedItemsToRemoteAsync(): Promise<boolean>;

}
